import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_27pwtoqk4e: FaireBrandEntity = {
  token: "b_27pwtoqk4e",
  type: "brand",
  name: "Ink Detroit",
  avatarUrl:
    "https://cdn.faire.com/fastly/6cf964be04ca5bd0c0c5af797af301387bdfed4b863a6a615477ab752a60a201.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0326dcf848f2558e275bef97834959b865276e2eecc0756d5ec09eef3dcc132.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6cf964be04ca5bd0c0c5af797af301387bdfed4b863a6a615477ab752a60a201.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0326dcf848f2558e275bef97834959b865276e2eecc0756d5ec09eef3dcc132.jpeg",
  location: "Hazel Park, MI, USA",
  minimumOrderDollars: 180,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Starting as a basement side hustle in the early 2000s, Ink Detroit has evolved into one of Michigan's favorite brands. Our mission is to capture the spirit of Detroit and the pride of Michigan, print it on the highest-quality garments available, and for Michiganders to wear as a badge of honor wherever they may be.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:02.430Z",
    importedBy: "entity-db-cli",
  },
};
